/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestSolvV2BondPriceOracleManager extends Contract<ITestSolvV2BondPriceOracleManager> {
  _setVoucherOracle: Send<(_voucher: AddressLike, _oracle: AddressLike) => void, ITestSolvV2BondPriceOracleManager>
  '_setVoucherOracle(address,address)': Send<(_voucher: AddressLike, _oracle: AddressLike) => void, ITestSolvV2BondPriceOracleManager>
  getOracle: Call<(_voucher: AddressLike) => string, ITestSolvV2BondPriceOracleManager>
  'getOracle(address)': Call<(_voucher: AddressLike) => string, ITestSolvV2BondPriceOracleManager>
  getPriceOfMaturity: Call<(_voucher: AddressLike, _fundCurrency: AddressLike, _maturity: BigNumberish) => BigNumber, ITestSolvV2BondPriceOracleManager>
  'getPriceOfMaturity(address,address,uint64)': Call<(_voucher: AddressLike, _fundCurrency: AddressLike, _maturity: BigNumberish) => BigNumber, ITestSolvV2BondPriceOracleManager>
}

let ITestSolvV2BondPriceOracleManagerBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestSolvV2BondPriceOracleManagerBytecode = '0x';
}

// prettier-ignore
export const ITestSolvV2BondPriceOracleManager = contract<ITestSolvV2BondPriceOracleManager>(ITestSolvV2BondPriceOracleManagerBytecode)`
  function _setVoucherOracle(address _voucher, address _oracle)
  function getOracle(address _voucher) view returns (address oracle_)
  function getPriceOfMaturity(address _voucher, address _fundCurrency, uint64 _maturity) view returns (int256 price_)
`;